<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="万里牛未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="星空未同步" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="flowshreport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
		<edit-index ref="rowedit" :row="currentrow" @success="success" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import editIndex from './lib/edit/index.vue'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				currentrow:null,
				loading:false,
				showUnsendjindie:false,
				showUnsendwln:false,
				showtransferaccount:false,
				transTime: null,
				reportName: 'reconciliation_bankflow',
				foreingKey:{},
				list_formConfig: [{
					field: 'serialNo',
					title: '单据编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'accName',
					title: '户名',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'bankAcc',
					title: '账号',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'oppAccName',
					title: '对方户名',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'oppAccNo',
					title: '对方账号',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'refundreason',
					title: '退款理由',
					span: 4,
					itemRender: {
						name: '$emun',
						props:{
							name:'refundreason',
							formatter:'refundreason'
						}
					}
				},{
					field: 'custommark',
					title: '自定义备注',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'transTime',
					title: '时间',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName,{
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},			
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'shreport_list'
				gridOptions.pagerConfig.enabled = true
				gridOptions.columns = [			
					{type:'checkbox',title:'#',fixed:'left',width:50},
					{field:'serialNo',title:'单据编码',render:'$input',props:{show:true},fixed:'left',width:150},
					{field:'accName',title:'户名',render:'$input',props:{show:true},width:100},
					{field:'bankAcc',title:'账号',render:'$input',props:{show:true},width:100},
					{
						field:'transTime',
						title:'时间',
						render:'$datePicker',
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue)
						},
						props:{show:true},
						width:100,
					},
					{field:'amt',title:'交易金额',render:'',props:{show:true},width:100},
					{field:'bal',title:'余额',render:'',props:{show:true},width:100},
					{field:'oppAccName',title:'对方户名',render:'',props:{show:true},width:100},
					{field:'oppAccNo',title:'对方账号',render:'',props:{show:true},width:100},
					{field:'showName',title:'店铺名称',render:'',props:{show:true},width:100},
					{field:'refundreason',title:'退款理由',render:'',props:{
						show:true,			
					},formatter:({cellValue})=>{
						return window.systemMethods.getEmunValue('refundreason',cellValue)
					},width:100},
					{field:'img_file',title:'付款凭证',render:'',formatter:'file',props:{
						show:true,						
					},slots:{
						default: ({row}) => {
							if(row.img_file){
								return <upload value={row.img_file} readonly />
							}
							return null
						}
					},width:100},
					
					{field:'serialId',title:'流水ID',render:'',props:{show:true},fixed:'right',width:200},
					{field:'relationtype',title:'关联方式',render:'',props:{show:true},fixed:'right',
						formatter:({cellValue})=>{
							return cellValue == 1?'自动':'手动'
						},width:100},
					{field:'custommark',title:'自定义备注',render:'',props:{show:true},fixed:'right',width:100},					
					{field:'export_wln',title:'万里牛',render:'',props:{show:true},fixed:'right',width:100},
					{field:'export_jindie',title:'金蝶',render:'',props:{show:true},fixed:'right',width:100},
					{field:'export_jindie_type',title:'金蝶模块',render:'',props:{show:true},fixed:'right',width:100},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {								
								return [
									<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.custommark(row)}}>备注</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>
								]
							}
						}
					}
				]
				gridOptions.checkboxConfig = null
				
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '同步万里牛',
					status: 'success',
					code: 'sendwln'
				},{
					name: '同步金蝶',
					status: 'warning',
					code: 'sendjindie'
				}]
				gridOptions.columns.forEach((item)=>{
					if(item.field=='serialNo'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.cdSign==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.cdSign==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								str.push(<span>{row.serialNo}</span>)
								return str
							}
						}
					}
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie_sucess!=1){
									if(row.export_jindie_error){
										return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span style="color:#67C23A;">已同步</span> 	
								}
							}
						}
					}
				})
			},
			showstream(row){
				this.streamdata = row.stream
				this.$refs.skstream.modal_show()
			},
			sendjindie(){
				let data =  this.$refs.flowshreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs.flowshreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendwln({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})				
			},
			receipt(row) {
				this.param = {code:row.paymentapplicationcode}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				// this.currentrow = row
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.purchasesupplierid,
				// 	id: row.paymentapplicationid,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.receiptType = row.ordertype
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()

				// },()=>{
				// 	this.$loadingclose(handle)
				// })
				
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.serialNo
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.flowshreport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},
			custommark(row){
				this.$prompt('请输入内容【'+row.serialNo+'】','提示').then(({ value })=>{
					this.$api.reconciliation_bankflow.custommark({
						fundtype:this.fundtype,
						bancktype:this.bancktype,
						custommark:value,
						id:row.id
					}).then(() => {
						row.custommark = value
					})
				})
			},
			edit(row){
				// if(row.relationtype == 1){
				// 	this.$message.error('自动关联的流水无法编辑')
				// 	return
				// }
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.flowshreport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.flowshreport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			editIndex
			// exportTable,
			// receiptIndex,
			// statisticsIndex,
			// editIndex
		}
	}
</script>